import { countNameOccurrences } from '@/utils';
import { useMemo } from 'react';

export interface ISelectedRow {
	id: number;
	name: string;
	subId?: number;
}
interface IUseSelectedItemsProps {
	selectedRows: ISelectedRow[];
}

export const addIdSuffixForDuplicates = (items: ISelectedRow[]) => {
	const nameCounts = countNameOccurrences(items);
	return items.map((item) => ({
		...item,
		folderName:
			nameCounts[item.name] > 1 ? `${item.name}_ID${item.id}` : item.name,
	}));
};

export const useSelectedItems = ({ selectedRows }: IUseSelectedItemsProps) => {
	const selectedItems = useMemo(() => {
		const items =
			selectedRows?.map((item) => ({
				id: item.id,
				name: item.name,
				subId: item?.subId,
			})) || [];

		return addIdSuffixForDuplicates(items);
	}, [selectedRows]);

	return selectedItems;
};
